import { MATEO_PHOTO, SOFIA_PHOTO } from './testimonialPhotos';

export type Tomo = {
  number: number;
  title: string;
  subtitle?: string;
  description: string;
  points: string[];
};
export type Bono = {
  number: number;
  title: string;
  format: string;
  description: string;
  price: string;
};
export type Outcome = {
  title: string;
  text: string;
};
export type MenuRef = {
  code: string;
  name: string;
  people: number;
  pricePerPerson: number;
};
export type Faq = {
  question: string;
  answer: string[];
};

// Aritmética de la oferta: única fuente para hero, oferta, bonos, FAQ y CTA final.
export const PRICE = '$299.99 MXN';
export const TOMOS_VALUE = '$235.00 MXN';
export const BONOS_VALUE = '$365.00 MXN';
export const TOTAL_VALUE = '$600.00 MXN';
export const SAVINGS = '$300.01 MXN';
export const DISCOUNT = '50%';

export const painPoints: string[] = [
  'Te piden "unos bocadillos para la junta" y no sabes cuántas piezas llevar por persona.',
  'Cobras "a ojo" y al final no sabes si ganaste o si pusiste dinero de tu bolsa.',
  'Haces todo el mismo día, a las carreras, y algo se enfría, se pone aguado o no llega bonito.',
  'Te escriben por WhatsApp y no sabes qué contestar, cuánto pedir de anticipo ni cómo confirmar.',
  'Quieres empezar en serio, pero no sabes qué trámites te tocan ni por dónde empezar.'
];

export const tomos: Tomo[] = [{
  number: 1,
  title: 'Recetas que se Venden Solas',
  subtitle: '40 recetas · R01 a R40',
  description: 'Los bocadillos que más se piden en México, estandarizados para que salgan iguales cada vez y sepas cuánto te cuesta cada pieza.',
  points: [
    'Rendimiento, porción, merma y costo por pieza en cada receta',
    'Bases que se repiten: tinga, frijoles, guacamole y salsas',
    'Sopes, tostaditas, canapés, brochetas, horneados y dulces de charola',
    '25 bocados vegetarianos',
    'Charolas que se ven bien en foto y empaque según el bocado'
  ]
}, {
  number: 2,
  title: 'Un Menú para Cada Reunión',
  subtitle: '6 menús · M1 a M6',
  description: 'Seis menús completos.',
  points: [
    'Cantidades por receta y piezas por persona según la reunión',
    'Lista de compras de cada menú',
    'Cronograma hora por hora desde dos días antes',
    'Armado de charolas, empaque, transporte y montaje',
    'Precio sugerido de referencia por persona'
  ]
}, {
  number: 3,
  title: 'Tu Primer Mes de Pedidos',
  subtitle: 'Paso a paso para tus primeros pedidos',
  description: 'Un plan día por día para pasar de las recetas a los pedidos cobrados, con una tarea, una plantilla y un ejemplo resuelto en cada capítulo.',
  points: [
    'Tu propuesta en una frase, costeo completo y precio por persona',
    'Fotos con el celular y catálogo en WhatsApp Business e Instagram',
    'Dónde buscar a tus primeros clientes',
    'Cotización, anticipo, confirmación y registro de pedidos',
    'Lo básico para vender en regla: RESICO y aviso de funcionamiento (guía orientativa)'
  ]
}];

export const bonos: Bono[] = [{
  number: 1,
  title: 'Calculadora Precio Justo',
  format: 'PDF',
  description: 'Método y fichas de costeo por receta y por menú, con ejemplos resueltos: ingredientes, merma, empaque, tu trabajo, gas, luz y entrega.',
  price: '$79.00 MXN'
}, {
  number: 2,
  title: 'Menús Listos para Vender',
  format: 'PDF',
  description: 'Un catálogo con los seis menús para personalizar con tu nombre comercial y enseñárselo a tus clientes.',
  price: '$59.00 MXN'
}, {
  number: 3,
  title: 'Cotiza y Cierra',
  format: 'Excel',
  description: 'Una plantilla de Excel que calcula el costo, el precio, el anticipo y la confirmación del pedido.',
  price: '$99.00 MXN'
}, {
  number: 4,
  title: 'Mensajes que Venden por WhatsApp e Instagram',
  format: 'PDF',
  description: 'Textos listos para copiar: primera consulta, cotización, seguimiento, "¿me haces descuento?", anticipo, recordatorio, entrega, reseña y recompra.',
  price: '$79.00 MXN'
}, {
  number: 5,
  title: 'Pedidos en Orden',
  format: 'PDF',
  description: 'Hoja de pedido, bitácora del mes, listas de compras de los seis menús y cronogramas de producción, listos para imprimir.',
  price: '$49.00 MXN'
}];

export const menus: MenuRef[] = [
  { code: 'M1', name: 'Café de oficina', people: 10, pricePerPerson: 135 },
  { code: 'M2', name: 'Botana para el partido', people: 10, pricePerPerson: 155 },
  { code: 'M3', name: 'Botanero mexicano', people: 20, pricePerPerson: 145 },
  { code: 'M4', name: 'Cumpleaños o celebración', people: 20, pricePerPerson: 120 },
  { code: 'M5', name: 'Fiesta familiar', people: 30, pricePerPerson: 115 },
  { code: 'M6', name: 'Evento de trabajo', people: 30, pricePerPerson: 115 }
];

export const outcomes: Outcome[] = [{
  title: 'Contestar con un menú, no con un "déjame ver"',
  text: 'Cuando te pidan un pedido, eliges uno de los seis menús y ya sabes qué llevar y cuántas piezas por persona.'
}, {
  title: 'Saber cuánto te cuesta cada pieza',
  text: 'Cada receta trae su rendimiento y su costo por pieza, y el método para sumarle tu trabajo, el gas, la luz y la entrega.'
}, {
  title: 'Mandar una cotización clara',
  text: 'Con la plantilla de Excel calculas el precio, el anticipo y el texto de confirmación del pedido.'
}, {
  title: 'Ir al súper con la lista hecha',
  text: 'Cada menú trae su lista de compras, lista para imprimir.'
}, {
  title: 'Cocinar con un horario, no a las carreras',
  text: 'Sigues el cronograma hora por hora desde dos días antes y entregas charolas armadas y empacadas.'
}, {
  title: 'Saber si de verdad ganaste',
  text: 'Anotas cada pedido en el registro y comparas lo que cobraste contra lo que gastaste.'
}];

export type Mensaje = {
  text: string;
  photo?: string;
};

export type Testimonio = {
  name: string;
  // Cada mensaje es una burbuja de chat, en el orden en que se mandaron.
  messages: Mensaje[];
};

// Testimonios reales de clientes (2026-10-25), cortados entre oraciones sin cambiar el texto.
export const testimonios: Testimonio[] = [{
  name: 'Mateo Hernández',
  messages: [{
    text: 'Yo ya preparaba comida para reuniones familiares, pero me daba pendiente aceptar pedidos porque nunca sabía cuánto hacer.'
  }, {
    text: 'Lo que más me sirvió fue tener las cantidades y las compras organizadas.'
  }, {
    text: 'Con esta charola pude seguir un orden y no dejar todo para el último momento.',
    photo: MATEO_PHOTO
  }]
}, {
  name: 'Sofía García',
  messages: [{
    text: '¡Así me quedaron los taquitos! 😊',
    photo: SOFIA_PHOTO
  }, {
    text: 'Primero los preparé para una reunión en casa y me gustó tener una idea de cómo ofrecerlos por pedido.'
  }, {
    text: 'Todavía estoy practicando la presentación, pero las porciones y la lista de compras me facilitaron bastante.'
  }]
}, {
  name: 'Santiago Martínez',
  messages: [{
    text: 'Lo compré sobre todo por la parte de costos.'
  }, {
    text: 'Yo calculaba los ingredientes, pero se me olvidaban los envases, la entrega y mi tiempo.'
  }, {
    text: 'El ejemplo de presupuesto me ayudó a ordenar esos gastos y entender mejor cuánto me cuesta cada pedido.'
  }]
}];

export const faqs: Faq[] = [{
  question: '¿Cómo lo recibo después de comprar?',
  answer: [
    'El acceso es digital e inmediato: al confirmar tu pago recibes un correo con el acceso.',
    'Los 3 tomos y los bonos 1, 2, 4 y 5 son archivos PDF; el Bono 3 es una plantilla de Excel. Puedes verlos en tu celular, tablet o computadora, o imprimirlos. No es un producto físico.'
  ]
}, {
  question: '¿Me sirve si nunca he vendido comida?',
  answer: [
    'Sí. Está pensado para personas que ya cocinan bien y quieren empezar a vender por encargo.',
    'El Tomo 3 es un paso a paso que va desde definir tu propuesta y costear tus recetas hasta cotizar, cobrar el anticipo y registrar tus primeros pedidos.'
  ]
}, {
  question: '¿En qué moneda pago?',
  answer: [
    `El precio está en pesos mexicanos (${PRICE}). Si compras desde otro país, el cobro se convierte a tu moneda al tipo de cambio del momento.`
  ]
}, {
  question: '¿Incluye las recetas y las cantidades exactas?',
  answer: [
    'Sí. Las 40 recetas traen ingredientes, rendimiento, porción, merma y costo por pieza.',
    'Los 6 menús traen las cantidades por receta, la lista de compras, el cronograma hora por hora, el armado de charolas y un precio sugerido de referencia por persona.'
  ]
}, {
  question: '¿Me sirve si no vivo en México?',
  answer: [
    'Está pensado para México: los bocadillos, los precios de referencia y la parte de trámites son de allá.',
    'Las recetas, los menús y el método de costeo se pueden aplicar en otros países ajustando los precios de tus ingredientes.'
  ]
}, {
  question: '¿Necesito equipo profesional?',
  answer: [
    'No. Todo está pensado para una cocina doméstica. El Tomo 2 te ayuda a calcular tu capacidad real: equipo, espacio en el refrigerador y horas disponibles.'
  ]
}, {
  question: '¿Es asesoría legal o fiscal?',
  answer: [
    'No. La parte de RESICO, aviso de funcionamiento y trámites es una guía orientativa para que sepas por dónde empezar.',
    'Confírmalo con un contador y con la autoridad sanitaria de tu estado antes de tomar decisiones.'
  ]
}, {
  question: '¿El Excel funciona en Google Sheets?',
  answer: [
    'Se abre en Excel; también puedes subirlo a Google Sheets.'
  ]
}, {
  question: '¿Los 5 bonos están incluidos?',
  answer: [
    'Sí. Los 5 bonos vienen con tu compra, sin costo extra.',
    `El valor total (3 tomos + 5 bonos) es de ${TOTAL_VALUE}. Hoy lo pagas a ${PRICE}.`
  ]
}];
